"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var invitationChecks_exports = {};
__export(invitationChecks_exports, {
  cancel: () => cancel,
  create: () => create,
  remove: () => remove,
  update: () => update
});
module.exports = __toCommonJS(invitationChecks_exports);
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_create = require("../check/create.js");
var import_check = require("../check/index.js");
function create(invite) {
  return import_check.check.named(
    invite.workspaceId == null ? `Create an invitation in the global admin area` : `Create an invitation in workspace ${invite.workspaceId}`,
    updateInternal(
      invite.workspaceId,
      invite.roles,
      invite.qualificationRoles,
      () => import_check.check.never("Invitations must contain at least one role")
    )
  );
}
function update(invite) {
  const status = (0, import_types.invitationStatus)(invite);
  switch (status) {
    case "Accepted":
      return import_check.check.never("Invitation has been accepted");
    case "Canceled":
      return import_check.check.never("Invitation has been canceled");
    case "Expired":
      return import_check.check.never("Invitation has expired");
    case "Pending":
      return import_check.check.named(
        invite.workspaceId == null ? `Update invitation ${invite.id} in the global admin area` : `Update invitation ${invite.id} in workspace ${invite.workspaceId}`,
        updateInternal(
          invite.workspaceId,
          invite.roles,
          invite.qualificationRoles,
          () => import_check.check.never("Invitations must contain at least one role")
        )
      );
    default:
      return (0, import_util.checkExhausted)(status);
  }
}
function cancel(invite) {
  const status = (0, import_types.invitationStatus)(invite);
  return import_check.check.named(
    `Cancel invitation ${invite.id} (currently ${status})`,
    updateInternal(invite.workspaceId, invite.roles, invite.qualificationRoles, () => import_create.always)
  );
}
function remove(invite) {
  const status = (0, import_types.invitationStatus)(invite);
  const canDelete = () => import_check.check.named(
    invite.workspaceId == null ? `Update invitation ${invite.id} in the global admin area` : `Update invitation ${invite.id} in workspace ${invite.workspaceId}`,
    updateInternal(invite.workspaceId, invite.roles, invite.qualificationRoles, () => import_create.always)
  );
  switch (status) {
    case "Accepted":
    case "Canceled":
    case "Expired":
      return canDelete();
    case "Pending":
      return import_check.check.never("Only accepted/canceled/expired invitations can be deleted");
    default:
      return (0, import_util.checkExhausted)(status);
  }
}
function updateInternal(workspaceId, roles, qualificationRoles, orElse) {
  return import_check.check.and(
    workspaceId == null ? import_check.check.globalAdmin : import_check.check.workspaceActive(workspaceId),
    import_check.check.canGrantRoles(roles, qualificationRoles, orElse)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  cancel,
  create,
  remove,
  update
});
//# sourceMappingURL=invitationChecks.js.map
